<template>
  <div class="invoice-notes-and-qrcode">
    <div class="invoice-notes">
      <div v-if="notes" class="invoice-description-info">
        <h3 class="invoice-description-info-title">
          Notes
        </h3>
        <div class="invoice-description-info-body" v-html="notes" />
      </div>
      <div v-if="conditions" class="invoice-description-info">
        <h3 class="invoice-description-info-title">
          Terms and conditions
        </h3>
        <div class="invoice-description-info-body" v-html="conditions" />
      </div>
    </div>
    <div class="invoice-qrcode">
      <div class="invoice-qrcode-wrapper">
        <img :src="qrCodeUrl">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotesAndConditions",

  props: {
    notes: { type: String },
    conditions: { type: String },
    qrCodeUrl: { type: String }
  }
};
</script>
